import { render } from "./KatisashiModal.vue?vue&type=template&id=79a7f599&scoped=true"
import script from "./KatisashiModal.vue?vue&type=script&lang=js"
export * from "./KatisashiModal.vue?vue&type=script&lang=js"

import "./KatisashiModal.vue?vue&type=style&index=0&id=79a7f599&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a7f599"]])

export default __exports__